import React from "react";
import { BookOpen, Sparkles, Users, PartyPopper } from "lucide-react";
import { PILLARS, ASSETS } from "@/data/content";
import { Reveal } from "@/lib/reveal";

const ICONS = { BookOpen, Sparkles, Users, PartyPopper };
// all real photographs in this section
const MEDIA = {
 ledger: { src: "gathering", type: "photo" },
 mirror: { src: "crowd", type: "photo" },
 forum: { src: "soilPit", type: "photo" },
 celebration: { src: "speaker", type: "photo" },
};

export const Pillars = () => (
 <section id="pillars" data-testid="pillars" className="relative bg-paper py-24 md:py-32">
 <div className="mx-auto max-w-[1400px] px-5 md:px-10">
 <div className="grid gap-6 md:grid-cols-[1.5fr_1fr] md:items-end">
 <Reveal>
 <h2 className="max-w-3xl font-display text-4xl font-medium leading-[1.02] text-ink sm:text-5xl lg:text-6xl">
 A Ledger. A Mirror. <span className="text-carbon">A Forum.</span> A Celebration.
 </h2>
 </Reveal>
 <Reveal delay={0.05}>
 <p className="font-body text-base text-ink/70 md:text-lg">
 Four things the Almanac is, at once, a book that records, reflects, convenes and honours the people rebuilding how Australia grows food and fibre and restores our soil.
 </p>
 </Reveal>
 </div>

 <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
 {PILLARS.map((p, i) => {
 const Icon = ICONS[p.icon];
 const m = MEDIA[p.key];
 const isWc = m.type === "wc";
 return (
 <Reveal key={p.key} delay={i * 0.08}>
 <article data-testid={`pillar-${p.key}`}
 className="group flex h-full flex-col overflow-hidden rounded-2xl border border-clay bg-cream transition-all duration-500 hover:-translate-y-2 hover:shadow-[0_28px_60px_rgba(42,32,21,0.18)]">
 <div className={`relative h-44 overflow-hidden ${isWc ? "bg-gradient-to-b from-sage/25 to-cream" : ""}`}>
 <img src={ASSETS[m.src]} alt={p.title}
 className={`h-full w-full transition-transform duration-700 group-hover:scale-105 ${isWc ? "object-contain object-bottom pt-3" : "object-cover"}`} />
 {!isWc && <div className="absolute inset-0 bg-gradient-to-t from-ink/70 via-ink/10 to-transparent" />}
 <span className="absolute left-4 top-4 inline-flex h-11 w-11 items-center justify-center rounded-full bg-carbon text-white shadow-lg">
 <Icon size={18} />
 </span>
 <span className={`absolute bottom-3 right-4 font-display text-4xl font-light ${isWc ? "text-ink/25" : "text-cream/90"}`}>0{i + 1}</span>
 </div>
 <div className="flex flex-1 flex-col p-6">
 <h3 className="font-display text-2xl font-medium text-forest">{p.title}</h3>
 <p className="mt-1 font-script text-xl text-terracotta">{p.line}</p>
 <p className="mt-3 font-body text-sm leading-relaxed text-ink/70">{p.body}</p>
 </div>
 </article>
 </Reveal>
 );
 })}
 </div>
 </div>
 </section>
);
